import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { http } from "@next-core/http";
/**
 * @description 校验系统权限
 * @endpoint POST /api/micro_app/v1/permission/validate
 */
export var PermissionApi_validatePermissions = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (data, options) {
    return (/**! @contract easyops.api.micro_app.permission.ValidatePermissions@1.0.0 */(yield http.post("api/gateway/micro_app.permission.ValidatePermissions/api/micro_app/v1/permission/validate", data, options)).data
    );
  });
  return function PermissionApi_validatePermissions(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
//# sourceMappingURL=validatePermissions.js.map